var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirrarrdown16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-320)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#2b639c"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90)",
    d: "m0.58789-325c1.191 2.9269 4.0659 5 7.4121 5 4.4064 0 8-3.5936 8-8s-3.5936-8-8-8c-3.3462 0-6.2212 2.0731-7.4121 5h2.2109c1.0341-1.7961 2.9704-3 5.2012-3 3.3255 0 6 2.6744 6 6s-2.6745 6-6 6c-2.2307 0-4.1671-1.2039-5.2012-3z",
    color: "#000000",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328 0a1 1 0 0 0-1 1v7.5859l-1.293-1.293a1 1 0 0 0-0.70703-0.29297 1 1 0 0 0-0.70703 0.29297 1 1 0 0 0 0 1.4141l3 3a1 1 0 0 0 1.4141 0l3-3a1 1 0 0 0 0-1.4141 1 1 0 0 0-0.70703-0.29297 1 1 0 0 0-0.70703 0.29297l-1.293 1.293v-7.5859a1 1 0 0 0-1-1z",
    color: "#000000",
    strokeLinecap: "round",
    style: {
      InkscapeStroke: "none"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirrarrdown16);
export default __webpack_public_path__ + "static/media/cirrarr.down.16.51d0f1a035392f823fbcfa069f8c2ab7.svg";
export { ForwardRef as ReactComponent };